var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.invoice
    ? _c("div", { staticClass: "main-content invoice-view-page" }, [
        _c("div", { staticClass: "page-header" }, [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(" " + _vm._s(_vm.invoice.reference_number)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-actions row" },
            [
              _c(
                "a",
                {
                  staticClass:
                    "mr-3 invoice-action-btn base-button btn btn-outline-primary default-size",
                  attrs: {
                    href: "/invoices/export/" + _vm.invoice.unique_hash,
                    target: "_blank",
                    color: "theme",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("general.export_invoice")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.invoice.status === "DRAFT" && _vm.userType == "supplier"
                ? _c(
                    "base-button",
                    {
                      attrs: {
                        loading: _vm.isSendingEmail,
                        disabled: _vm.isSendingEmail,
                        color: "theme",
                      },
                      on: { click: _vm.onSendInvoice },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("invoices.send_invoice")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userType == "supplier" &&
              _vm.invoice.request_level == "Not Eligible" &&
              _vm.invoice.paid_status != "PAID" &&
              _vm.invoice.pre_pay == 0 &&
              (_vm.invoice.status === "SENT" ||
                _vm.invoice.status === "VIEWED" ||
                _vm.invoice.status === "OVERDUE")
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        to:
                          "/supplier/payments/" +
                          _vm.invoice.id +
                          "/payment/create",
                      },
                    },
                    [
                      _c("base-button", { attrs: { color: "theme" } }, [
                        _vm._v(_vm._s(_vm.$t("payments.record_payment")) + " "),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userType == "anchor" &&
              (_vm.invoice.paid_status === "UNPAID" ||
                _vm.invoice.paid_status == "PARTIALLY_PAID") &&
              (_vm.invoice.status === "SENT" ||
                _vm.invoice.status === "VIEWED" ||
                _vm.invoice.status === "OVERDUE") &&
              _vm.invoice.pre_pay == 1 &&
              (_vm.invoice.request_level == "Eligible" ||
                _vm.invoice.request_level == "Rejected" ||
                _vm.invoice.request_level == "Prepaid")
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        to: "/anchor/payments/" + _vm.invoice.id + "/create",
                      },
                    },
                    [
                      _c("base-button", { attrs: { color: "theme" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("payments.record_payment")) + " "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userType == "funder" &&
              _vm.invoice.request_level == "Financed" &&
              _vm.invoice.prepayment == null
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        to:
                          "/funder/payments/" +
                          _vm.invoice.id +
                          "/prepayment/create",
                      },
                    },
                    [
                      _c("base-button", { attrs: { color: "theme" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("invoices.make_prepayment")) + " "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userType === "supplier" &&
              _vm.invoice.payment_receiver &&
              _vm.invoice.payment_receiver.account.account_type == "supplier" &&
              _vm.invoice.request_level == "Prepaid" &&
              _vm.invoice.overall_status == "PAID" &&
              _vm.invoice.paid_status == "PAID" &&
              _vm.invoice.pre_pay == 1 &&
              _vm.invoice.status === "SENT"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        to:
                          "/supplier/payments/" +
                          _vm.invoice.id +
                          "/settlement/create",
                      },
                    },
                    [
                      _c("base-button", { attrs: { color: "theme" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("general.need_settlement")) + "  "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userType === "funder" &&
              _vm.invoice.payment_receiver &&
              _vm.invoice.payment_receiver.account.account_type == "funder" &&
              _vm.invoice.request_level == "Prepaid" &&
              _vm.invoice.overall_status == "PAID" &&
              _vm.invoice.paid_status == "PAID" &&
              _vm.invoice.pre_pay == 1 &&
              _vm.invoice.status === "SENT"
                ? _c(
                    "router-link",
                    [
                      _c("base-button", { attrs: { color: "theme" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("general.need_settlement")) + "  "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.status == "DRAFT" && _vm.userType == "supplier"
                ? _c(
                    "v-dropdown",
                    {
                      staticClass: "filter-container",
                      attrs: { "close-on-select": false, align: "left" },
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "activator", href: "#" },
                          slot: "activator",
                        },
                        [
                          _c(
                            "base-button",
                            { attrs: { color: "theme" } },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "ellipsis-h" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-dropdown-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: {
                                to: {
                                  path:
                                    "/supplier/invoices/" +
                                    _vm.$route.params.id +
                                    "/edit",
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "dropdown-item-icon",
                                attrs: { icon: ["fas", "pencil-alt"] },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("general.edit")) +
                                  "\n          "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.removeInvoice(_vm.$route.params.id)
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "dropdown-item-icon",
                                attrs: { icon: ["fas", "trash"] },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("general.delete")) +
                                  "\n          "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "invoice-sidebar" },
          [
            _c(
              "div",
              { staticClass: "side-header" },
              [
                _c("base-input", {
                  attrs: {
                    placeholder: _vm.$t("general.search"),
                    "input-class": "inv-search",
                    icon: "search",
                    type: "text",
                    "align-icon": "right",
                  },
                  on: { input: _vm.onSearch },
                  model: {
                    value: _vm.searchData.searchText,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchData, "searchText", $$v)
                    },
                    expression: "searchData.searchText",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-group ml-3",
                    attrs: { role: "group", "aria-label": "First group" },
                  },
                  [
                    _c(
                      "v-dropdown",
                      {
                        staticClass: "filter-container",
                        attrs: { "close-on-select": false, align: "left" },
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: { slot: "activator", href: "#" },
                            slot: "activator",
                          },
                          [
                            _c(
                              "base-button",
                              {
                                staticClass: "inv-button inv-filter-fields-btn",
                                attrs: { color: "default", size: "medium" },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "filter" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "filter-title" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("general.sort_by")) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "filter-items" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchData.orderByField,
                                expression: "searchData.orderByField",
                              },
                            ],
                            staticClass: "inv-radio",
                            attrs: {
                              id: "filter_invoice_date",
                              type: "radio",
                              name: "filter",
                              value: "invoice_date",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.searchData.orderByField,
                                "invoice_date"
                              ),
                            },
                            on: {
                              change: [
                                function ($event) {
                                  return _vm.$set(
                                    _vm.searchData,
                                    "orderByField",
                                    "invoice_date"
                                  )
                                },
                                _vm.onSearch,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "inv-label",
                              attrs: { for: "filter_invoice_date" },
                            },
                            [_vm._v(_vm._s(_vm.$t("invoices.invoice_date")))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "filter-items" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchData.orderByField,
                                expression: "searchData.orderByField",
                              },
                            ],
                            staticClass: "inv-radio",
                            attrs: {
                              id: "filter_due_date",
                              type: "radio",
                              name: "filter",
                              value: "due_date",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.searchData.orderByField,
                                "due_date"
                              ),
                            },
                            on: {
                              change: [
                                function ($event) {
                                  return _vm.$set(
                                    _vm.searchData,
                                    "orderByField",
                                    "due_date"
                                  )
                                },
                                _vm.onSearch,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "inv-label",
                              attrs: { for: "filter_due_date" },
                            },
                            [_vm._v(_vm._s(_vm.$t("invoices.due_date")))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "filter-items" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchData.orderByField,
                                expression: "searchData.orderByField",
                              },
                            ],
                            staticClass: "inv-radio",
                            attrs: {
                              id: "filter_invoice_number",
                              type: "radio",
                              name: "filter",
                              value: "invoice_number",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.searchData.orderByField,
                                "invoice_number"
                              ),
                            },
                            on: {
                              change: [
                                function ($event) {
                                  return _vm.$set(
                                    _vm.searchData,
                                    "orderByField",
                                    "invoice_number"
                                  )
                                },
                                _vm.onSearch,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "inv-label",
                              attrs: { for: "filter_invoice_number" },
                            },
                            [_vm._v(_vm._s(_vm.$t("invoices.invoice_number")))]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "base-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.top-center",
                            value: { content: _vm.getOrderName },
                            expression: "{ content: getOrderName }",
                            modifiers: { "top-center": true },
                          },
                        ],
                        staticClass: "inv-button inv-filter-sorting-btn",
                        attrs: { color: "default", size: "medium" },
                        on: { click: _vm.sortData },
                      },
                      [
                        _vm.getOrderBy
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "sort-amount-up" },
                            })
                          : _c("font-awesome-icon", {
                              attrs: { icon: "sort-amount-down" },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isSearching
              ? _c("base-loader")
              : _c(
                  "div",
                  { staticClass: "side-content" },
                  [
                    _vm._l(_vm.invoices, function (invoice, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          staticClass: "side-invoice",
                          attrs: { href: "#/" },
                          on: {
                            click: function ($event) {
                              return _vm.viewInvoice(invoice.id)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "left" }, [
                            _vm.userType == "supplier" ||
                            _vm.userType == "funder" ||
                            _vm.userType == "super_admin"
                              ? _c("div", { staticClass: "inv-name" }, [
                                  invoice.buyer_stakeholder
                                    ? _c("p", [
                                        invoice.buyer_stakeholder.details
                                          .company &&
                                        invoice.customer.parent_account_id &&
                                        invoice.buyer_stakeholder.details
                                          .company.name
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    invoice.buyer_stakeholder
                                                      .details.company.name
                                                  ) +
                                                  "\n              "
                                              ),
                                            ])
                                          : invoice.buyer_stakeholder.details
                                              .company &&
                                            invoice.customer
                                              .parent_account_id == null &&
                                            invoice.buyer_stakeholder.details
                                              .company.name
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    invoice.buyer_stakeholder
                                                      .details.user.name
                                                  ) +
                                                  "\n              "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm.userType == "anchor"
                              ? _c("div", { staticClass: "inv-name" }, [
                                  invoice.supplier_stakeholder
                                    ? _c("p", [
                                        invoice.supplier_stakeholder.details
                                          .company &&
                                        invoice.supplier_stakeholder.details
                                          .company.name
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    invoice.supplier_stakeholder
                                                      .details.company.name
                                                  ) +
                                                  "\n              "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "inv-number" }, [
                              _vm._v(_vm._s(invoice.reference_number)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "inv-status",
                                class:
                                  "inv-status-" + invoice.status.toLowerCase(),
                              },
                              [_vm._v(_vm._s(invoice.status))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right" }, [
                            _c("div", {
                              staticClass: "inv-amount",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$utils.formatMoney(
                                    invoice.nominal_amount,
                                    invoice.customer.currency
                                  )
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "inv-date" }, [
                              _vm._v(_vm._s(invoice.formattedInvoiceDate)),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !_vm.invoices.length
                      ? _c("p", { staticClass: "no-result" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("invoices.no_matching_invoices")) +
                              "\n      "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "invoice-view-page-container" }, [
          _c("iframe", {
            staticClass: "frame-style",
            attrs: { src: "" + _vm.shareableLink },
          }),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }